<div class="flex flex-col gap-medpace-field">
    @for (error of formGroup().errors | keyvalue; track error.key) {
        <medpace-alert [appearance]="'danger'" [content]="error.value" />
    }

    <mds-radio-group
        [class.hidden]="(needsFlightTravel$ | async) === false"
        [buttons]="useFlightDateRadioButtons"
        [formCtrl]="formGroup().controls.useFlightDate"
    />
    <div [class.hidden]="(useFlightDetails$ | async) === false" class="grid grid-cols-3 gap-medpace-field">
        <mds-autocomplete
            id="airportDestination"
            [label]="'Airport (Destination)'"
            [appearance]="'outline'"
            [formCtrl]="airportDestination"
        />
        <mds-datepicker
            id="departureDate"
            [label]="'Departure Date'"
            [appearance]="'outline'"
            [formCtrl]="departureDate"
        />
        @if ((flightTravelType$ | async) === TravelType.ROUND_TRIP) {
            <mds-datepicker id="returnDate" [label]="'Return Date'" [appearance]="'outline'" [formCtrl]="returnDate" />
        }
    </div>
    <div [class.hidden]="(useFlightDetails$ | async) === true" class="grid grid-cols-2 gap-medpace-field">
        <mds-autocomplete
            id="pickupAddress"
            [formCtrl]="formGroup().controls.pickupAddress"
            [appearance]="'outline'"
            [inputType]="'text'"
            [label]="'Pick-up Airport Or City'"
            [placeholder]="'Type here...'"
            [options]="autocompleteOptions().pickupAddress"
        />
        <mds-autocomplete
            id="pickupCountry"
            [formCtrl]="formGroup().controls.pickupCountry"
            [options]="countryOptions()"
            [appearance]="'outline'"
            [placeholder]="'Enter country'"
            [label]="'Country'"
            [validateInput]="true"
            [closeOnPageScroll]="false"
        ></mds-autocomplete>
        <medpace-datepicker
            [formCtrl]="formGroup().controls.pickupDate"
            [appearance]="'outline'"
            [label]="'Pick-up Date'"
            [required]="true"
            id="pickupDate"
        />
        <mds-dropdown
            id="pickupTime"
            floatLabel="always"
            [formCtrl]="formGroup().controls.pickupTime"
            [appearance]="'outline'"
            [label]="'Pick-up Time'"
            [placeholder]="'Select time'"
            [options]="timeOptions()"
            [closeOnPageScroll]="false"
        />
        <medpace-datepicker
            id="dropOffDate"
            [formCtrl]="formGroup().controls.dropOffDate"
            appearance="outline"
            label="Drop-off Date"
            [required]="true"
        />
        <mds-dropdown
            id="dropOffTime"
            floatLabel="always"
            [formCtrl]="formGroup().controls.dropOffTime"
            [appearance]="'outline'"
            [label]="'Drop-off Time'"
            [placeholder]="'Select time'"
            [options]="timeOptions()"
            [closeOnPageScroll]="false"
        />
    </div>
    <medpace-textarea-autocomplete
        [formCtrl]="formGroup().controls.specialRequests"
        [options]="autocompleteOptions().specialRequests"
        [cdkAutosizeMaxRows]="20"
        [cdkAutosizeMinRows]="5"
        label="Special Requests"
        placeholder="Special requests - e.g. ADA accessible"
        appearance="outline"
        [autoSize]="true"
        id="specialRequests"
    />
</div>
